import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useRef, useState } from 'react';

function isFunctionalUpdate(action) {
  return typeof action === 'function';
}

export default function useControlledState(state, defaultState, onStateChange) {
  var initialState = state !== undefined ? state : defaultState;

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var ref = useRef({
    isControlled: state !== undefined,
    state: value
  });
  var wasControlled = ref.current.isControlled;
  var isControlled = state !== undefined;

  if (wasControlled !== isControlled) {
    console.warn("WARNING: A component changed from ".concat(wasControlled ? 'controlled' : 'uncontrolled', " ") + "to ".concat(isControlled ? 'controlled' : 'uncontrolled', "."));
  }

  ref.current.isControlled = isControlled;
  var setState = useCallback(function (action) {
    function update(nextState) {
      if (typeof onStateChange === 'function') {
        if (ref.current.state !== action) {
          onStateChange(nextState);
        }
      }

      if (!isControlled) {
        ref.current.state = nextState;
      }
    }

    if (isFunctionalUpdate(action)) {
      setValue(function (prevState) {
        var nextState = action(isControlled ? ref.current.state : prevState);
        update(nextState);
        return !isControlled ? nextState : prevState;
      });
    } else {
      if (!isControlled) {
        setValue(action);
      }

      update(action);
    }
  }, [isControlled, onStateChange]);

  if (isControlled) {
    ref.current.state = state;
  }

  return [isControlled ? state : value, setState];
}